<template>
  <div class="dropdown-button">
    <button
      role="menuitem"
      aria-haspopup="true"
      aria-controls="app-bar-help-menu"
      :aria-expanded="showHelpDropdown"
      class="app-bar-button"
      @click="showHelpDropdown = true"
      v-t:title="'Help'"
    >
      <base-icon size="small" name="help_outline" />
    </button>
    <div v-if="showHelpDropdown" class="dropdown-menu">
      <div class="dropdown dropdown-with-curtain" @click.self="cancel">
        <div id="app-bar-help-menu" role="menu" class="dropdown-content">
          <div class="tv tv-list">
            <a role="menuitem" class="tv-cell tv-cell-default" target="_blank" href="https://padlet.com/blog"
              ><base-icon name="news" /><span v-t>News</span></a
            >
            <a role="menuitem" class="tv-cell tv-cell-default" target="_blank" href="http://jn.padlet.com"
              ><base-icon name="book_shelf" /><span v-t>Knowledge base</span></a
            >
            <a role="menuitem" class="tv-cell tv-cell-default" target="_blank" href="https://www.youtube.com/padlet"
              ><base-icon name="videocam" /><span v-t>Video tutorials</span></a
            >
            <a role="menuitem" class="tv-cell tv-cell-default" href="mailto:hello@padlet.com"
              ><base-icon name="envelope" /><span v-t>Email us</span></a
            >
            <div v-if="xChat" class="tv-cell tv-cell-default tv-cell-actionable" role="menuitem" @click="showChat">
              <base-icon name="comment" /><span v-t>Message us</span>
            </div>
            <a
              v-if="showTwitter"
              role="menuitem"
              class="tv-cell tv-cell-default"
              target="_blank"
              href="https://twitter.com/padlet"
              ><base-icon name="twitter" /><span v-t>Tweet at us</span></a
            >
            <a
              v-if="showReddit"
              role="menuitem"
              class="tv-cell tv-cell-default"
              target="_blank"
              href="https://www.reddit.com/r/padlet"
              ><base-icon name="reddit" /><span v-t>Reddit commmunity</span></a
            >
          </div>
          <div class="tv-section-divider" />
          <div class="tv tv-list">
            <a role="menuitem" class="tv-cell tv-cell-default" target="_blank" href="https://padlet.com/about"
              ><base-icon name="info_outline" /><span v-t>About</span></a
            >
            <a
              role="menuitem"
              class="tv-cell tv-cell-default"
              target="_blank"
              href="https://padlet.com/about/accessibility"
              ><base-icon name="accessibility" /><span v-t>Accessibility</span></a
            >
            <a role="menuitem" class="tv-cell tv-cell-default" target="_blank" href="https://padlet.com/about/apps"
              ><base-icon name="puzzle" /><span v-t>Apps and plugins</span></a
            >
            <a role="menuitem" class="tv-cell tv-cell-default" target="_blank" href="/premium"
              ><base-icon name="rocket" /><span v-t>Premium plans</span></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import BaseIcon from 'vuecomponents/base_icon'
import EscapeToCancelMixin from 'vuemixins/escape_to_cancel_mixin'
import { showWidget } from 'bits/helpscout'
import t from 'vuedirectives/t'

export default {
  components: { BaseIcon },
  directives: { t },
  mixins: [EscapeToCancelMixin],
  props: ['user'],
  data() {
    return {
      showHelpDropdown: false,
    }
  },
  computed: {
    showReddit() {
      return this.user.role !== 'student'
    },
    showTwitter() {
      return this.user.role !== 'student'
    },
    xChat() {
      return this.user.role !== 'student' && this.user.paying
    },
  },
  methods: {
    cancel() {
      this.showHelpDropdown = false
    },
    showChat() {
      const identity = {
        name: this.user.name || this.user.username,
        username: this.user.username,
        email: this.user.email,
        paying: this.user.paying,
        avatar: this.user.avatar,
      }
      showWidget(identity, 'chat')
      this.cancel()
    },
  },
}
</script>
